import React, { FunctionComponent, useCallback, useMemo } from 'react';
import { AdminApi } from 'src/api';
import useApiCall from 'src/hooks/use-api-call';
import Translate from 'ui/atoms/translate';
import { Modal, ModalHeader, ModalContent, ModalFooter, ModalFooterButtons } from 'ui/molecules/modal';

interface ReactivateUserConfirmModalProps {
  userId: string;
  userName: string;
  onSuccess: () => void;
  onClose: () => void;
}

const ReactivateUserConfirmModal: FunctionComponent<ReactivateUserConfirmModalProps> = ({
  onClose,
  onSuccess,
  userId,
  userName,
}) => {
  const { withApi, makeAuthenticatedApi } = useApiCall();

  const adminApi: AdminApi = useMemo(() => makeAuthenticatedApi(AdminApi), [makeAuthenticatedApi]);

  const onCtaClick = useCallback(() => {
    withApi(async () => {
      await adminApi.adminUsersPartialUpdate({
        id: userId,
        patchedAdminUserPartialUpdateRequest: { isActive: true },
      });

      onSuccess();
      onClose();
    });
  }, [userId, withApi, adminApi]);

  return (
    <Modal onClose={onClose}>
      <ModalHeader>
        <Translate name="reactivateUserConfirmModal.title" />
      </ModalHeader>
      <ModalContent>
        <Translate name="reactivateUserConfirmModal.content" args={[<strong>{userName}</strong>]} />
      </ModalContent>
      <ModalFooter>
        <ModalFooterButtons
          actionButtons={[
            {
              name: 'close',
              content: <Translate name="common.cancel" />,
              size: 'large',
              onClick: () => onClose(),
            },
            {
              name: 'reactivate',
              variant: 'primary',
              content: <Translate name="reactivateUserConfirmModal.button" />,
              size: 'large',
              onClick: () => onCtaClick(),
            },
          ]}
        />
      </ModalFooter>
    </Modal>
  );
};

export default ReactivateUserConfirmModal;
